
import MatchHistory from './MatchHistory.vue';
import MxModal from '@/components/global/MxModal.vue';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { IFileEncoderConfigurationAnalysisResource, IFileExaminationResult, IFileGenerationHistory, IFileOriginatingDevice } from '@/types/resource.types';

@Component({
    name: 'FileEncoderConfigurationAnalysis',
    components: {
        MatchHistory,
        MxModal
    }
})
export default class FileEncoderConfigurationAnalysis extends Vue {

    @Prop({ type: Object, required: false })
    readonly eca: IFileEncoderConfigurationAnalysisResource;

    @Prop({ type: Object, required: true })
    readonly fileResult: IFileExaminationResult;

    showModal: boolean = false;

    showSummary() {
        this.showModal = !this.showModal;
    }

    get showMatches(): boolean {
        return this.fileResult?.matchHistory.length > 0;
    }

    get device(): IFileOriginatingDevice | undefined {
        return this.fileResult?.originatingDevice;
    }

    get history(): IFileGenerationHistory | undefined {
        return this.fileResult?.generationHistory;
    }

    get classifiedBrand(): string {
        if(this.fileResult.originatingDevice?.classifiedBrand ) {
            return this.fileResult.originatingDevice.classifiedBrand;
        }else if(this.fileResult.brandClassification){
            return this.fileResult.brandClassification.predictedValue;
        }
        return '';
    }

    get classifiedDevice(): string {
        if(this.fileResult.originatingDevice?.classifiedDevice) {
            return this.fileResult.originatingDevice.classifiedDevice;
        }else if(this.fileResult.modelClassification){
            return this.fileResult.modelClassification.predictedValue;
        }
        return '';
    }

    get classifiedLastGeneration(): string {
        if(this.fileResult.lastGenerationClassification?.predictedValue){
            return this.fileResult.lastGenerationClassification.predictedValue;
        }
        return '';
    }

    get matchEcaText(): string {
        if (this.eca?.matches?.some(match => match.matchType === 1)) return 'Fuzzy ECA Match';
        if (this.eca?.matches?.length) return 'ECA Match';
        return 'No ECA Match';
    }

    get matchEcaType(): string {
        if (this.eca?.matches?.some(match => match.matchType === 1)) return 'warning';
        if (this.eca?.matches?.length) return 'success';
        return '';
    }
}

